/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box } from '@mantine/core';

// Components
import { ResetPassword } from '@features/update-password/components/ResetPassword';

// Styles
import classes from './update-password.module.css';

// I18n

// Localstorage
import { JwtPayload, jwtDecode } from 'jwt-decode';

// Router
import { useLocation } from 'react-router';

// Utils
import {
	BG_INUK,
	BG_INUK_MOBILE,
	BG_INUK_TABLET,
	CONTACT_US_INUK_URL,
} from '@config/constants/common';
import { REGEX_TOKEN } from '@config/constants/regex';
import { BackgroundImageAuth } from '@features/auth/components/BackgroundImageAuth';
import { FooterInfo } from '@features/auth/components/FooterInfo';
import { useBreakpoint } from '@hooks/useBreakpoint';
import { isTokenExpired } from '@utils/auth';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
type CustomJwtPayload = Partial<JwtPayload> & {
	email: string;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

const UpdatePassword = () => {
	/* ******************************** HOOKS ******************************* */
	const { isTablet } = useBreakpoint();
	const location = useLocation();
	const queryParams = new URLSearchParams(
		location.search
	);

	const token = queryParams.get('token')
		? queryParams.get('token')
		: '';

	const decodedPayload =
		token && REGEX_TOKEN.test(token)
			? jwtDecode<CustomJwtPayload>(token)
			: null;

	const email = decodedPayload
		? decodedPayload.email
		: '';

	const isValidToken = REGEX_TOKEN.test(
		token ? token : ''
	);

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Box className={classes.leftContainer}>
				<Box className={classes.backgroundImageMobile}>
					<BackgroundImageAuth
						url={
							isTablet ? BG_INUK_TABLET : BG_INUK_MOBILE
						}
					/>
				</Box>
				<Box
					className={classes.containerFormTabletMobile}
				>
					<ResetPassword
						token={token || ''}
						email={email}
						isValidToken={isValidToken}
						isTokenExpired={isTokenExpired(token)}
					/>
					<FooterInfo
						contactUsUrl={CONTACT_US_INUK_URL}
					/>
				</Box>
				<Box className={classes.containerFormDesktop}>
					<ResetPassword
						token={token || ''}
						email={email}
						isValidToken={isValidToken}
						isTokenExpired={isTokenExpired(token)}
					/>
					<FooterInfo
						contactUsUrl={CONTACT_US_INUK_URL}
					/>
				</Box>
			</Box>
			<Box className={classes.rightContainer}>
				<BackgroundImageAuth url={BG_INUK} />
			</Box>
		</Box>
	);
};

export default UpdatePassword;
